/* eslint-env browser */
import './index.scss';

import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom';

import { DocumentPage } from '../universal/components/DocumentPage';
import type { AppProps, InitialData } from '../universal/types';
import sentryConfig from '../universal/util/sentry-config';
import {
    getGoogleAnalyticsTracker,
    getMonitorTracker,
    getStoryTracker,
    getWebsiteTracker,
} from '../universal/util/tracking';

const elm = document.getElementById('initial-data');
const initialData: InitialData = JSON.parse((elm && elm.getAttribute('data-json')) || '');

if (initialData.config) {
    Sentry.setTag('workspace', 'frontend');
    Sentry.init({
        ...sentryConfig(initialData.config.sentry),
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 0.1,
        allowUrls: [
            initialData.config.hosts.main, // inline javascript
            initialData.config.hosts.static, // client.js, header.js, footer.js, etc
            'www.googletagmanager.com', // Injection of cookie consent, various trackers, etc.
            'consent.cookiebot.com', // Cookie consent script
            'cdnjs.cloudflare.com', // Third-party packages loaded from CDN
        ],
        ignoreErrors: [
            'NS_ERROR_UNEXPECTED', // Generic FF error message, not enough information to fix
            /SecurityError: Blocked a restricted frame with origin ".*" from accessing another frame/, // Comes from 3rd party scripts
            'ResizeObserver loop limit exceeded', // As suggested by the author of that library: https://stackoverflow.com/a/50387233
            'The play() request was interrupted by', // Most likely caused by Primis ads
            'Blocked a frame with origin "https://issuu.com" from accessing a cross-origin frame', // Comes from ads
        ],
    });
}

const appProps: AppProps = {
    ...initialData,
    monitorTracker: getMonitorTracker(initialData.config.hosts.pingback),
    websiteTracker: getWebsiteTracker(initialData.config.hosts.pingback, initialData.referrer),
    storyTracker: getStoryTracker(initialData.config.hosts.pingback, initialData.referrer),
    googleAnalyticsTracker: getGoogleAnalyticsTracker(),
};

function render() {
    const el = document.getElementById('app');
    el && ReactDOM.hydrate(<DocumentPage {...appProps} />, el);
}

render();
